var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useState } from "react";
/**
 * Tracks which Od/Do datepickers of a filter pane hold text that is not a valid date. The draft
 * filter value of such a field is "", so without this the bound would be dropped silently.
 */
export var useDateInputValidity = function () {
    var _a = useState({}), invalidInputs = _a[0], setInvalidInputs = _a[1];
    var _b = useState(0), inputsKey = _b[0], setInputsKey = _b[1];
    var setInputInvalid = useCallback(function (key, invalid) {
        return setInvalidInputs(function (prev) {
            var _a;
            return !!prev[key] === invalid ? prev : __assign(__assign({}, prev), (_a = {}, _a[key] = invalid, _a));
        });
    }, []);
    var resetInputs = useCallback(function () {
        setInvalidInputs({});
        setInputsKey(function (key) { return key + 1; });
    }, []);
    return {
        invalidInputs: invalidInputs,
        hasInvalidInput: Object.values(invalidInputs).some(Boolean),
        setInputInvalid: setInputInvalid,
        resetInputs: resetInputs,
        inputsKey: inputsKey,
    };
};
